import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AlertAudioService {
  private audio = new Audio('/assets/sounds/notification.mp3');
  private unlocked = false;

  constructor() {
    this.audio.preload = 'auto';
    this.audio.volume = 0.8; // ajusta si quieres
  }

  async unlock(): Promise<void> {
    // Llamar esto tras una interacción del usuario (click/tap)
    if (this.unlocked) return;

    try {
      this.audio.muted = true;
      await this.audio.play();   // arranca “silencioso” para desbloquear
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio.muted = false;
      this.unlocked = true;
    } catch {
      // Si falla, lo intentas de nuevo en el próximo gesto del usuario
      this.unlocked = false;
    }
  }

  async playAlert(): Promise<void> {
    try {
      // Reinicia para permitir múltiples alerts seguidas
      this.audio.currentTime = 0;
      await this.audio.play();
    } catch {
      // Si está bloqueado por autoplay, aquí no sonará.
      // Solución: asegúrate de llamar unlock() en el primer click del usuario.
    }
  }
}